import { Subject } from "@mui/icons-material"
import SearchableDropdown from "../../Common/SearchableDropdown"
import axios from "axios";
import Swal from "sweetalert2";
import * as yup from 'yup';
import { useFormik } from "formik";
import { useEffect } from "react";
import Modal from 'react-bootstrap/Modal';

const validationSchema = yup.object({
    organizationId: yup.string("Please select a organization").required("Organization is required"),
    name: yup.string("Enter the subject name").required("Subject Name is required"),
    email: yup
      .string('Enter the email')
      .email('Enter a valid email')
      .required('Email is required'),
    preferredPronoun: yup.string('Enter the preferred pronoun').required('Preferred Pronoun is required')
})

export const AddSubject = ({editId, setEditId, organizations, getSubjects, type, show, setShow, ...rest}) => {

    const handleClose = () => setShow(false);

    const initialValues = {
        id: editId,
        organizationId: '',
        name: '',
        email: '',
        preferredPronoun: '',
    }

    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: validationSchema,
        onSubmit: values => {
            handleSubmit(values);
        }
    });

    const handleSubmit = (values) =>{
        if(editId > 0){
            axios.put(`api/subjectUpdate`, values).then(res => {                
                setEditId(0)
                setShow(false)
                if(res.data.success){
                    Swal.fire(res.data.message, '', 'success').then(result => {
                        getSubjects();
                    })
                } 
                else{
                    Swal.fire(res.data.message, '', 'error')
                }
            }).catch((error) => {
                setShow(false)
                Swal.fire(error.response.data.message, '', 'error')
            });
        }
        else{
            axios.post(`api/subjectCreate`, values).then(res => {
                setShow(false)
                if(res.data.success){
                    Swal.fire(res.data.message, '', 'success').then(result => {
                        formik.resetForm();
                        getSubjects();
                    })                
                } 
                else{
                    Swal.fire(res.data.message, '', 'error')
                }
            }).catch((error) => {
                setShow(false)
                Swal.fire(error.response.data.message, '', 'error')
            });
        }        
    }

    const handleChangeOrg = (event, value) => {
        // console.log("Autocomplete value",value)
        if(value && value.id){
            formik.setFieldValue('organizationId', value.id)
        }
        else{
            formik.setFieldValue('organizationId', '')
        }
    }

    useEffect(() => {
        getSubjects();
        if(editId > 0){
            axios.get(`api/subject?id=${editId}`).then(res => {
                if(res.data.success){
                    formik.setFieldValue('id', res.data.data.id)
                    formik.setFieldValue('name', res.data.data.name)
                    formik.setFieldValue('email', res.data.data.email)
                    formik.setFieldValue('preferredPronoun', res.data.data.preferredPronoun)
                    formik.setFieldValue('organizationId', res.data.data.organizationId)
                }
            })
        }
        else{
            formik.resetForm();
        }
        
    },[show]);

    const handlePopupClose = () => {
        formik.resetForm();
        handleClose();
    }
    return (
        <Modal show={show} onHide={handlePopupClose}>
            <Modal.Header closeButton>
            <Modal.Title>{type} Subject</Modal.Title>
            </Modal.Header>
                <form onSubmit={formik.handleSubmit}>
                    <Modal.Body>                                               
                        <div className="col-md-12">                                    
                            <div className="mb-3">
                                <SearchableDropdown label="Select Organization" list={organizations} onChange={handleChangeOrg}  value={formik.values.organizationId} />
                                {formik.touched.organizationId && formik.errors.organizationId && (<div className="text-danger">{formik.errors.organizationId}</div>)}
                            </div>                                
                        </div>
                        <div className="col-md-12">
                            <div className="mb-3">
                                <label className="form-label" htmlFor="basic-icon-default-name">Subject Name</label>
                                <div className="input-group input-group-merge">
                                    <span id="basic-icon-default-name" className="input-group-text"><i className="bx bx-user"></i></span>
                                    <input type="text" name="name" className="form-control" id="basic-icon-default-name" placeholder="Subject Name" aria-label="Subject Name" aria-describedby="basic-icon-default-fullname2"
                                    onChange={formik.handleChange} 
                                    onBlur={formik.handleBlur}
                                    value={formik.values.name}/>
                                </div>
                                {formik.touched.name && formik.errors.name && (<div className="text-danger">{formik.errors.name}</div>)}
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-6">
                                <div className="mb-3">
                                    <label className="form-label" htmlFor="basic-icon-default-email">Email</label>
                                    <div className="input-group input-group-merge">
                                        <span className="input-group-text"><i className="bx bx-envelope"></i></span>
                                        <input type="email" name="email" id="basic-icon-default-email" className="form-control" placeholder="Rajiv.doe@example.com" aria-label="Rajiv.doe@example.com" aria-describedby="basic-icon-default-email2" onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.email} />
                                    </div>
                                    {formik.touched.email && formik.errors.email && (<div className="text-danger">{formik.errors.email}</div>)}
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="mb-3">
                                    <label className="form-label" htmlFor="basic-icon-default-preferredPronoun">Preferred Pronoun</label>
                                    <div className="input-group input-group-merge">
                                        <span id="basic-icon-default-preferredPronoun" className="input-group-text"><i className="bx bx-bullseye"></i></span>
                                        <input type="text" name="preferredPronoun" id="basic-icon-default-preferredPronoun" className="form-control phone-mask" placeholder="Preferred Pronoun" aria-label="Preferred Pronoun" aria-describedby="basic-icon-default-preferredPronoun" onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.preferredPronoun} />
                                    </div>
                                    {formik.touched.preferredPronoun && formik.errors.preferredPronoun && (<div className="text-danger">{formik.errors.preferredPronoun}</div>)}
                                </div>
                            </div>
                        </div>  
                    </Modal.Body>
                    <Modal.Footer>
                        <button type="button" className="btn btn-outline-secondary" data-bs-dismiss="modal" onClick={handlePopupClose}>Close</button>
                        <button type="submit" className="btn btn-primary">{type == 'Add' ? 'Add' : 'Update'}</button>
                    </Modal.Footer>
                </form>
        </Modal>
    )
}